import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { ApiFetchError } from '@nrdy-marketing-engine/api-fetch/src/api-fetch';
import { Me } from '@nrdy-marketing-engine/cart/@types/me';

export class FetchUser {
  usersMeGet = () =>
    apiFetch<Me>('/v1/users/me?include_entity=true&include_students=true').catch((err) => {
      if (err instanceof ApiFetchError && err.response.status.toString().startsWith('4')) {
        return null;
      }
      throw err;
    });
}
